__turbopack_context__.v({
  "hitsList": "BfPWBa_hitsList",
  "searchHitsContainer": "BfPWBa_searchHitsContainer",
});
